import { convertDmyToYmd } from '../dateFuncs';

export interface IDateOfLoss {
    dateOfLoss: string;
    dateToday: Date;
}

/**
 * Validates if the provided date of loss is within the acceptable range (not older than 3 years).
 *
 * @param {IDateOfLoss} input - An object containing the date of loss and the current date.
 * @param {string} input.dateOfLoss - The date of loss in DD-MM-YYYY format.
 * @param {Date} input.dateToday - Todays date.
 * @returns {boolean} - Returns `true` if the date of loss is valid, otherwise `false`.
 */
export const isDateOfLossValid = (input: IDateOfLoss): boolean => {
    const dateOfLoss = new Date(convertDmyToYmd(input.dateOfLoss));

    // date of loss must not be in the future
    if (dateOfLoss > input.dateToday) {
        return false;
    }

    // date of loss must not be older than 3 years
    const dateOfLossLimit = new Date(
        input.dateToday.getFullYear() - 3,
        input.dateToday.getMonth(),
        input.dateToday.getDate()
    );

    if (dateOfLoss < dateOfLossLimit) {
        return false;
    }

    return true;
};
